/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40IDIuNjc5OTlMOC4wMDAwMSA1LjA4OTk5TDUuNjAwMDEgMi42Nzk5OUw0Ljg5MDAxIDMuMzg5OTlMOC4wMDAwMSA2LjQ5OTk5TDExLjExIDMuMzg5OTlMMTAuNCAyLjY3OTk5Wk01LjYwMDAxIDEzLjMyTDguMDAwMDEgMTAuOTJMMTAuNCAxMy4zMkwxMS4xMSAxMi42Mkw4LjAwMDAxIDkuNTA5OTlMNC44OTAwMSAxMi42Mkw1LjYwMDAxIDEzLjMyWiIgZmlsbD0iaW5oZXJpdCIvPg==";